import { store } from './store'
export const addReducer = (name, reducer) => {
  store.addReducer(name, reducer)
}
